// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SearchResultsContent__container___IoDtl {
    overflow: hidden;
    display: flex;
    flex-grow: 1;
}

.SearchResultsContent__resultsTable___DuXAa {
    flex-grow: 1;
    width: 100vh;
    padding-right: 1.2rem;
    padding-bottom: 1.2rem;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/OverallImport/NewImportResults/SearchResultsContent/SearchResultsContent.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,qBAAqB;IACrB,sBAAsB;AAC1B","sourcesContent":[".container {\n    overflow: hidden;\n    display: flex;\n    flex-grow: 1;\n}\n\n.resultsTable {\n    flex-grow: 1;\n    width: 100vh;\n    padding-right: 1.2rem;\n    padding-bottom: 1.2rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SearchResultsContent__container___IoDtl`,
	"resultsTable": `SearchResultsContent__resultsTable___DuXAa`
};
export default ___CSS_LOADER_EXPORT___;
